import { useEffect } from 'react';

import authStore from '../store/AuthStore';
import userActivityStore from '../store/UserActivityStore';

export const useBeforeUnload = (): void => {
  useEffect(() => {
    if (authStore.authenticatedUser) {
      window.addEventListener('beforeunload', userActivityStore.onCloseTab);
    }
    return () =>
      window.removeEventListener('beforeunload', userActivityStore.onCloseTab);
  }, [authStore.authenticatedUser]);
};
